import { Injectable } from '@angular/core';
import { AuthService } from "../services/auth.service";
import {Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getAuthorizationToken();
    let request: HttpRequest<any> = req;

    if (token && !this.authService.isTokenExpired(token)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request)
      .pipe(
        catchError((error) => this.handleError(error))  // Passa a funÃ§Ã£o de tratamento do erro
      );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Ocorreu um erro, tente novamente';  


    if (error.error instanceof ErrorEvent) {
      
    } else {
      if (error.error && error.error.detail) {
        errorMessage = `Erro: ${error.error.title} | Detalhes: ${error.error.detail}`;
      } else if (error.error && error.error.fieldErrors) {
        const fieldErrors = Object.entries(error.error.fieldErrors).map(
          ([field, message]) => `${field}: ${message}`
        ).join(' | ');

        errorMessage = `Erros de campo: ${fieldErrors}`;
      } else {
        errorMessage = `CÃ³digo do erro: ${error.status} | Mensagem: ${error.error?.message || 'Erro desconhecido'}`;
      }
    }
    return throwError(() => new Error(errorMessage));
  }

}
